(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suklaaf-about"]) return;
  try {
    
  class SuklaafAbout extends HTMLElement {
    #ctx = null;

    connectedCallback() {
      // Allow DOM and deferred CDN scripts to load
      this.#init();
    }

    disconnectedCallback() {
      if (this.#ctx) {
        this.#ctx.revert();
      }
    }

    #init() {
      if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        setTimeout(() => this.#init(), 100);
        return;
      }
      gsap.registerPlugin(ScrollTrigger);
      this.#createAnimations();
    }

    #createAnimations() {
      this.#ctx = gsap.context(() => {
        // Simple scale effect on Hero background
        gsap.fromTo('.suklaaf-about-hero__bg',
          { scale: 1 },
          {
            scale: 1.12,
            scrollTrigger: {
              trigger: '.suklaaf-about-hero',
              start: 'top top',
              end: 'bottom top',
              scrub: true
            }
          }
        );

        // GSAP Responsive animation triggers
        const mm = gsap.matchMedia();

        // 1. Desktop Animations (min-width: 768px)
        mm.add("(min-width: 768px)", () => {
          // A. Tension Split Section Animation (Scroll Driven ClipPath)
          const splitTl = gsap.timeline({
            scrollTrigger: {
              trigger: '.suklaaf-tension',
              start: 'top top',
              end: '+=150%',
              pin: true,
              scrub: true,
              anticipatePin: 1
            }
          });

          splitTl.to('.suklaaf-tension__screen--pleasure', {
            clipPath: 'inset(0% 0% 0% 0%)',
            ease: 'none'
          }, 0)
          .to('.suklaaf-tension__divider', {
            left: '100%',
            ease: 'none'
          }, 0);

          // B. Scrollytelling Pinned Image Swaps
          const slides = gsap.utils.toArray('.suklaaf-scrolly__slide');
          slides.forEach((slide, idx) => {
            if (idx === 0) return; // The first visual card is already opacity: 1 by default

            gsap.to(`.suklaaf-scrolly__visual-card[data-index="${idx}"]`, {
              opacity: 1,
              scrollTrigger: {
                trigger: slide,
                start: 'top 50%',
                end: 'top 20%',
                scrub: true
              }
            });

            // Fade out the previous card
            gsap.to(`.suklaaf-scrolly__visual-card[data-index="${idx - 1}"]`, {
              opacity: 0,
              scrollTrigger: {
                trigger: slide,
                start: 'top 50%',
                end: 'top 20%',
                scrub: true
              }
            });
          });

          // C. Horizontal Ingredient Slides scroll
          const track = this.querySelector('.suklaaf-pillars__track');
          const container = this.querySelector('.suklaaf-pillars__container');
          
          if (track && container) {
            const scrollWidth = track.scrollWidth - container.offsetWidth;
            
            gsap.to(track, {
              x: -scrollWidth,
              ease: 'none',
              scrollTrigger: {
                trigger: '.suklaaf-pillars',
                start: 'top top',
                end: () => `+=${scrollWidth}`,
                pin: true,
                scrub: true,
                anticipatePin: 1
              }
            });
          }
        });
      }, this);
    }
  }

  // Register Web Component only if not already defined
  if (!customElements.get('suklaaf-about')) {
    customElements.define('suklaaf-about', SuklaafAbout);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suklaaf-hero"] && !Shopify.designMode) return;
  try {
    
  // Carousel logic removed as this is now a single static background image

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suklaaf-ingredients"] && !Shopify.designMode) return;
  try {
    
  class SuklaafIngredientsCarousel extends HTMLElement {
    #index = 0;
    #timer = null;
    #slides = [];
    #dots = [];
    #prevBtn = null;
    #nextBtn = null;
    #total = 0;
    #autoAdvance = false;
    #intervalMs = 6000;
    #prefersReduced = false;
    #onVisibility = null;

    connectedCallback() {
      this.#slides = Array.from(this.querySelectorAll('.suklaaf-ingredients__slide'));
      this.#dots = Array.from(this.querySelectorAll('[data-suklaaf-ingredients-dot]'));
      this.#prevBtn = this.querySelector('[data-suklaaf-ingredients-prev]');
      this.#nextBtn = this.querySelector('[data-suklaaf-ingredients-next]');
      this.#total = this.#slides.length;
      if (this.#total < 1) return;

      this.#autoAdvance = this.dataset.autoAdvance !== 'false';
      this.#intervalMs = parseInt(this.dataset.interval, 10) || 6000;
      this.#prefersReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.#index = this.#slides.findIndex((el) => el.classList.contains('is-active'));
      if (this.#index < 0) this.#index = 0;

      this.#syncControls();

      this.#dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.#goTo(i));
      });
      this.#prevBtn?.addEventListener('click', () => this.#prev());
      this.#nextBtn?.addEventListener('click', () => this.#next());

      this.addEventListener('mouseenter', () => this.#pause());
      this.addEventListener('mouseleave', () => this.#play());
      this.addEventListener('focusin', () => this.#pause());
      this.addEventListener('focusout', () => this.#play());
      this.addEventListener('keydown', this.#onKeydown);

      this.#onVisibility = () => {
        if (document.hidden) this.#pause();
        else this.#play();
      };
      document.addEventListener('visibilitychange', this.#onVisibility);

      this.#play();
    }

    disconnectedCallback() {
      this.#pause();
      this.removeEventListener('keydown', this.#onKeydown);
      if (this.#onVisibility) {
        document.removeEventListener('visibilitychange', this.#onVisibility);
      }
    }

    #onKeydown = (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.#prev();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.#next();
      }
    };

    #syncControls() {
      if (this.#total < 2) {
        if (this.#prevBtn) this.#prevBtn.disabled = true;
        if (this.#nextBtn) this.#nextBtn.disabled = true;
        return;
      }
      if (this.#prevBtn) this.#prevBtn.disabled = false;
      if (this.#nextBtn) this.#nextBtn.disabled = false;
    }

    #goTo(nextIndex) {
      if (this.#total < 2) return;
      const next = ((nextIndex % this.#total) + this.#total) % this.#total;
      if (next === this.#index) return;

      this.#slides[this.#index].classList.remove('is-active');
      this.#slides[this.#index].setAttribute('aria-hidden', 'true');
      this.#dots[this.#index]?.classList.remove('is-active');
      this.#dots[this.#index]?.setAttribute('aria-selected', 'false');

      this.#index = next;
      this.#slides[this.#index].classList.add('is-active');
      this.#slides[this.#index].setAttribute('aria-hidden', 'false');
      this.#dots[this.#index]?.classList.add('is-active');
      this.#dots[this.#index]?.setAttribute('aria-selected', 'true');

      this.#restart();
    }

    #next() { this.#goTo(this.#index + 1); }
    #prev() { this.#goTo(this.#index - 1); }

    #play() {
      if (!this.#autoAdvance || this.#prefersReduced || this.#total < 2) return;
      this.#pause();
      this.#timer = setInterval(() => this.#next(), this.#intervalMs);
    }

    #pause() {
      if (this.#timer) {
        clearInterval(this.#timer);
        this.#timer = null;
      }
    }

    #restart() {
      this.#pause();
      this.#play();
    }
  }

  if (!customElements.get('suklaaf-ingredients-carousel')) {
    customElements.define('suklaaf-ingredients-carousel', SuklaafIngredientsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suklaaf-intro"] && !Shopify.designMode) return;
  try {
    
  class SuklaafIntroReveal extends HTMLElement {
    #io = null;
    #heading = null;
    #onScroll = null;
    #raf = 0;

    connectedCallback() {
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const animated = this.classList.contains('suklaaf-intro--animated');

      // Secondary elements: staggered fade-in on enter.
      const targets = this.querySelectorAll('[data-suklaaf-intro-reveal]');
      if (reduced || !targets.length) {
        targets.forEach((el) => el.classList.add('is-visible'));
      } else {
        this.#io = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.#io.unobserve(entry.target);
              }
            }
          },
          { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
        );
        targets.forEach((el) => this.#io.observe(el));
      }

      // Heading: scroll-driven word/letter reveal.
      this.#heading = this.querySelector('[data-suklaaf-intro-heading]');
      if (!this.#heading) return;

      if (!animated || reduced) {
        this.style.setProperty('--reveal-progress', '1');
        return;
      }

      this.#setupUnitReveal();
    }

    #setupUnitReveal() {
      const heading = this.#heading;
      const granularity = this.classList.contains('suklaaf-intro--anim-letters')
        ? 'letters'
        : 'words';
      const text = (heading.textContent || '').trim();
      if (!text) return;

      // Build units (spans) while preserving whitespace.
      const frag = document.createDocumentFragment();
      let count = 0;

      if (granularity === 'letters') {
        for (const ch of text) {
          if (/\s/.test(ch)) {
            frag.appendChild(document.createTextNode(ch));
            continue;
          }
          const span = this.#makeUnit(ch, count);
          frag.appendChild(span);
          count++;
        }
      } else {
        const words = text.split(/\s+/).filter(Boolean);
        words.forEach((word, i) => {
          frag.appendChild(this.#makeUnit(word, i));
          if (i < words.length - 1) frag.appendChild(document.createTextNode(' '));
        });
        count = words.length;
      }

      heading.textContent = '';
      heading.style.setProperty('--unit-count', String(count));
      heading.appendChild(frag);

      // Map heading travel through the viewport to progress 0 → 1.
      const update = () => {
        this.#raf = 0;
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const rect = heading.getBoundingClientRect();
        const start = vh * 0.85;
        const end = vh * 0.28;
        const span = start - end || 1;
        let p = (start - rect.top) / span;
        p = Math.max(0, Math.min(1, p));
        this.style.setProperty('--reveal-progress', p.toFixed(4));
      };

      this.#onScroll = () => {
        if (this.#raf) return;
        this.#raf = requestAnimationFrame(update);
      };

      update();
      window.addEventListener('scroll', this.#onScroll, { passive: true });
      window.addEventListener('resize', this.#onScroll, { passive: true });
    }

    #makeUnit(content, index) {
      const span = document.createElement('span');
      span.className = 'suklaaf-intro__unit';
      span.style.setProperty('--unit-index', String(index));
      span.textContent = content;
      return span;
    }

    disconnectedCallback() {
      this.#io?.disconnect();
      this.#io = null;
      if (this.#onScroll) {
        window.removeEventListener('scroll', this.#onScroll);
        window.removeEventListener('resize', this.#onScroll);
      }
      if (this.#raf) cancelAnimationFrame(this.#raf);
      this.#raf = 0;
    }
  }

  customElements.define('suklaaf-intro-reveal', SuklaafIntroReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suklaaf-product-videos"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initVideos = (section) => {
      if (section.dataset.skvInit === '1') return;
      section.dataset.skvInit = '1';

      const carousel = section.querySelector('[data-skv-carousel]');
      const nextBtn = section.querySelector('[data-skv-nav="next"]');
      const prevBtn = section.querySelector('[data-skv-nav="prev"]');

      // ── Navigation scroll ──
      if (carousel) {
        const getScrollStep = () => {
          const firstCard = carousel.querySelector('.skv-videos__card');
          return firstCard ? firstCard.clientWidth + 24 : 300;
        };

        nextBtn?.addEventListener('click', () => {
          carousel.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
        });

        prevBtn?.addEventListener('click', () => {
          carousel.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
        });
      }

      // ── Lazy load & Play video inline ──
      section.addEventListener('click', (e) => {
        const playBtn = e.target.closest('[data-skv-play-btn]');
        if (!playBtn) return;

        const mediaContainer = playBtn.closest('[data-skv-media-container]');
        const videoUrl = playBtn.dataset.videoUrl;

        if (mediaContainer && videoUrl) {
          e.preventDefault();
          
          // Clear current content
          mediaContainer.innerHTML = '';

          // Create native video element
          const video = document.createElement('video');
          video.src = videoUrl;
          video.className = 'skv-videos__video';
          video.setAttribute('controls', 'true');
          video.setAttribute('playsinline', 'true');
          video.setAttribute('loop', 'true');

          mediaContainer.appendChild(video);
          
          // Auto-play the video
          video.play().catch((err) => {
            console.warn("Video auto-play blocked or failed", err);
          });
        }
      });
    };

    const boot = (root = document) => {
      for (const el of root.querySelectorAll('[data-skv-videos]')) {
        initVideos(el);
      }
    };

    boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suklaaf-product"] && !Shopify.designMode) return;
  try {
    
  class SuklaafProduct extends HTMLElement {
    connectedCallback() {
      this.thumbnails = this.querySelectorAll('[data-product-thumbnail]');
      this.slides = this.querySelectorAll('[data-product-slide]');
      this.packOptions = this.querySelectorAll('[data-pack-option]');
      this.stepperButtons = this.querySelectorAll('[data-stepper-change]');
      this.quantityInput = this.querySelector('[data-product-quantity]');
      this.stepperValue = this.querySelector('[data-stepper-value]');
      this.totalDisplay = this.querySelector('[data-product-total]');
      this.totalCompare = this.querySelector('[data-product-total-compare]');
      this.totalValue = this.querySelector('[data-product-total-value]');
      this.unitPriceCents = Number(this.dataset.unitPrice) || 0;
      this.currency = this.dataset.currency || 'USD';
      this.minQuantity = 1;
      this.maxQuantity = 99;
      this.discountTiers = [
        { min: 1, pct: Number(this.dataset.discountOne) || 0 },
        { min: 3, pct: Number(this.dataset.discountThree) || 0 },
        { min: 5, pct: Number(this.dataset.discountFive) || 0 },
        { min: 10, pct: Number(this.dataset.discountTen) || 0 },
      ].sort((a, b) => a.min - b.min);

      try {
        this.moneyFormatter = new Intl.NumberFormat(document.documentElement.lang, {
          style: 'currency',
          currency: this.currency,
        });
      } catch (error) {
        this.moneyFormatter = { format: (value) => `${this.currency} ${value.toFixed(2)}` };
      }

      for (const thumbnail of this.thumbnails) {
        thumbnail.addEventListener('click', this.handleThumbnailClick);
      }

      for (const option of this.packOptions) {
        option.addEventListener('change', this.handlePackChange);
      }

      for (const button of this.stepperButtons) {
        button.addEventListener('click', this.handleStepperClick);
      }

      this.thumbNavButtons = this.querySelectorAll('[data-thumb-scroll]');
      this.thumbsContainer = this.querySelector('.skp__thumbs');

      for (const btn of this.thumbNavButtons) {
        btn.addEventListener('click', this.handleThumbScroll);
      }

      if (this.thumbsContainer) {
        this.updateThumbNavState();
        this.thumbsContainer.addEventListener('scroll', this.updateThumbNavState, { passive: true });
        window.addEventListener('resize', this.updateThumbNavState, { passive: true });
      }

      this.stage = this.querySelector('.skp__stage');
      this.slideCounter = this.querySelector('[data-slide-counter]');
      if (this.stage) {
        this.stage.addEventListener('scroll', this.handleStageScroll, { passive: true });
      }

      this.setQuantity(this.minQuantity);
    }

    disconnectedCallback() {
      for (const thumbnail of this.thumbnails) {
        thumbnail.removeEventListener('click', this.handleThumbnailClick);
      }

      for (const option of this.packOptions) {
        option.removeEventListener('change', this.handlePackChange);
      }

      for (const button of this.stepperButtons) {
        button.removeEventListener('click', this.handleStepperClick);
      }

      for (const btn of this.thumbNavButtons) {
        btn.removeEventListener('click', this.handleThumbScroll);
      }

      if (this.thumbsContainer) {
        this.thumbsContainer.removeEventListener('scroll', this.updateThumbNavState);
        window.removeEventListener('resize', this.updateThumbNavState);
      }

      if (this.stage) {
        this.stage.removeEventListener('scroll', this.handleStageScroll);
      }
    }

    handleThumbnailClick = (event) => {
      const index = event.currentTarget.dataset.productThumbnail;

      for (const slide of this.slides) {
        const isActive = slide.dataset.slideIndex === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      }

      for (const thumbnail of this.thumbnails) {
        const isActive = thumbnail.dataset.productThumbnail === index;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-pressed', String(isActive));
      }
    };

    handleThumbScroll = (event) => {
      if (!this.thumbsContainer) return;
      const direction = Number(event.currentTarget.dataset.thumbScroll) || 1;
      const scrollAmount = this.thumbsContainer.clientHeight * 0.75;
      this.thumbsContainer.scrollBy({
        top: direction * scrollAmount,
        behavior: 'smooth',
      });
    };

    updateThumbNavState = () => {
      const thumbs = this.thumbsContainer;
      if (!thumbs) return;
      const prevBtn = this.querySelector('[data-thumb-scroll="-1"]');
      const nextBtn = this.querySelector('[data-thumb-scroll="1"]');

      if (this.thumbnails.length <= 4) {
        if (prevBtn) prevBtn.hidden = true;
        if (nextBtn) nextBtn.hidden = true;
        return;
      }

      const maxScroll = thumbs.scrollHeight - thumbs.clientHeight;
      const atStart = thumbs.scrollTop <= 2;
      const atEnd = thumbs.scrollTop >= maxScroll - 2;
      if (prevBtn) prevBtn.hidden = atStart;
      if (nextBtn) nextBtn.hidden = atEnd;
    };

    handleStageScroll = () => {
      if (!this.stage || !this.slideCounter) return;
      const slideWidth = this.stage.clientWidth;
      if (slideWidth === 0) return;
      const currentIdx = Math.round(this.stage.scrollLeft / slideWidth);
      this.slideCounter.textContent = `${currentIdx + 1} / ${this.slides.length}`;
    };

    handlePackChange = (event) => {
      this.setQuantity(Number(event.currentTarget.value));
    };

    handleStepperClick = (event) => {
      const delta = Number(event.currentTarget.dataset.stepperChange) || 0;
      const current = Number(this.quantityInput?.value) || this.minQuantity;
      this.setQuantity(current + delta);
    };

    setQuantity(quantity) {
      const clamped = Math.min(
        this.maxQuantity,
        Math.max(this.minQuantity, Math.round(quantity)),
      );

      if (this.quantityInput) this.quantityInput.value = String(clamped);
      if (this.stepperValue) this.stepperValue.textContent = String(clamped);

      const originalCents = this.unitPriceCents * clamped;
      const discountPct = this.getDiscountPct(clamped);
      const discountedCents = discountPct > 0
        ? Math.round((originalCents * (100 - discountPct)) / 100)
        : originalCents;

      if (this.totalValue) {
        this.totalValue.textContent = this.moneyFormatter.format(discountedCents / 100);
      }
      if (this.totalCompare) {
        if (discountPct > 0 && discountedCents !== originalCents) {
          this.totalCompare.textContent = this.moneyFormatter.format(originalCents / 100);
          this.totalCompare.hidden = false;
        } else {
          this.totalCompare.textContent = '';
          this.totalCompare.hidden = true;
        }
      }

      for (const option of this.packOptions) {
        const matches = Number(option.value) === clamped;
        option.checked = matches;
        option.closest('.skp__pack')?.classList.toggle('is-active', matches);
      }
    }

    getDiscountPct(quantity) {
      let pct = 0;
      for (const tier of this.discountTiers) {
        if (quantity >= tier.min) pct = tier.pct;
      }
      return pct;
    }
  }

  if (!customElements.get('suklaaf-product')) {
    customElements.define('suklaaf-product', SuklaafProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suklaaf-taste"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DESKTOP_BP = 990;
    const motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /**
     * @param {HTMLElement} section
     */
    const initTaste = (section) => {
      if (section.dataset.sktTasteInit === '1') return;
      section.dataset.sktTasteInit = '1';

      const tabs = section.querySelectorAll('[data-skt-tab]');
      const steps = section.querySelectorAll('[data-skt-step]');
      const images = section.querySelectorAll('[data-skt-img]');
      const progressFill = section.querySelector('[data-skt-progress]');

      if (!steps.length) return;

      section.classList.add('is-enhanced');

      // ── Reveal on scroll ──
      if (motionOk) {
        section.dataset.sktReveal = 'pending';
        const revealObs = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              section.dataset.sktReveal = 'visible';
              revealObs.disconnect();
            }
          },
          { threshold: 0.08 }
        );
        revealObs.observe(section);
      }

      let currentIndex = 0;

      /**
       * Activate a benefit step by index
       * @param {number} idx - 0-based index
       */
      const activate = (idx) => {
        if (idx === currentIndex && section.dataset.sktTasteFirst === undefined) return;
        delete section.dataset.sktTasteFirst;
        currentIndex = idx;

        // Update tabs
        for (const tab of tabs) {
          const tabIdx = parseInt(tab.dataset.sktTab, 10) - 1;
          const isActive = tabIdx === idx;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        }

        // Update cards / panels
        for (const step of steps) {
          const stepIdx = parseInt(step.dataset.sktStep, 10) - 1;
          const isActive = stepIdx === idx;
          step.classList.toggle('is-active', isActive);
          step.setAttribute('tabindex', isActive ? '0' : '-1');
        }

        // Update images
        for (const img of images) {
          const imgIdx = parseInt(img.dataset.sktImg, 10) - 1;
          img.classList.toggle('is-active', imgIdx === idx);
        }

        // Update progress
        const pct = ((idx + 1) / steps.length) * 100;
        section.style.setProperty('--_progress', `${pct}%`);
      };

      // Mark first run so first activate call goes through
      section.dataset.sktTasteFirst = '';
      activate(0);

      // ── Mobile: tab click handlers ──
      for (const tab of tabs) {
        tab.addEventListener('click', () => {
          const idx = parseInt(tab.dataset.sktTab, 10) - 1;
          activate(idx);
        });
      }

      // ── Mobile: keyboard navigation within tabs ──
      const tabList = section.querySelector('[role="tablist"]');
      if (tabList) {
        tabList.addEventListener('keydown', (e) => {
          const tabArr = Array.from(tabs);
          const focusedIdx = tabArr.indexOf(document.activeElement);
          if (focusedIdx === -1) return;

          let nextIdx = focusedIdx;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            nextIdx = (focusedIdx + 1) % tabArr.length;
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            nextIdx = (focusedIdx - 1 + tabArr.length) % tabArr.length;
          } else if (e.key === 'Home') {
            nextIdx = 0;
          } else if (e.key === 'End') {
            nextIdx = tabArr.length - 1;
          } else {
            return;
          }

          e.preventDefault();
          tabArr[nextIdx].focus();
          activate(nextIdx);
        });
      }

      // ── Mobile: swipe support on gallery ──
      const gallery = section.querySelector('.skt-taste__gallery');
      if (gallery) {
        let touchStartX = 0;
        let touchStartY = 0;

        gallery.addEventListener('touchstart', (e) => {
          touchStartX = e.touches[0].clientX;
          touchStartY = e.touches[0].clientY;
        }, { passive: true });

        gallery.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - touchStartX;
          const dy = e.changedTouches[0].clientY - touchStartY;

          // Only count horizontal swipes (not scrolls)
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            if (dx < 0 && currentIndex < steps.length - 1) {
              activate(currentIndex + 1);
            } else if (dx > 0 && currentIndex > 0) {
              activate(currentIndex - 1);
            }
          }
        }, { passive: true });
      }

      // ── Desktop: scroll-story with IntersectionObserver ──
      const isDesktop = () => window.innerWidth >= DESKTOP_BP;
      let storyObserver = null;

      const initScrollStory = () => {
        if (storyObserver) {
          storyObserver.disconnect();
          storyObserver = null;
        }

        if (!isDesktop() || !motionOk) return;

        storyObserver = new IntersectionObserver(
          (entries) => {
            // Find the most-visible entry
            let best = null;
            for (const entry of entries) {
              if (entry.isIntersecting) {
                if (!best || entry.intersectionRatio > best.intersectionRatio) {
                  best = entry;
                }
              }
            }
            if (best) {
              const idx = parseInt(best.target.dataset.sktStep, 10) - 1;
              activate(idx);
            }
          },
          {
            /* Vertical center band — avoids edge-triggering */
            rootMargin: '-28% 0px -38% 0px',
            threshold: [0, 0.15, 0.35, 0.55, 0.75, 1],
          }
        );

        for (const step of steps) storyObserver.observe(step);
      };

      initScrollStory();

      // Re-init on resize crossing the breakpoint
      let wasDesktop = isDesktop();
      const onResize = () => {
        const nowDesktop = isDesktop();
        if (nowDesktop !== wasDesktop) {
          wasDesktop = nowDesktop;
          initScrollStory();
        }
      };

      window.addEventListener('resize', onResize, { passive: true });
    };

    // ── Boot ──
    const boot = (root = document) => {
      for (const el of root.querySelectorAll('[data-skt-taste]')) {
        initTaste(el);
      }
    };

    boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
